import { combineReducers } from "redux-immutable";
import upload from "./upload/reducer";
import annotate from "./annotate/reducer";
import confirm from "./confirm/reducer";

const soloReducer = combineReducers({
  upload,
  annotate,
  confirm
});

export default soloReducer;
